import React, { useEffect, useRef, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import './HeroSection.css';

const CITIES = [
  { name: 'Toronto', coords: '43.65°N 79.38°W', tag: 'Late-Night Sessions' },
  { name: 'Tulum', coords: '20.21°N 87.46°W', tag: 'Sunrise Sets' },
  { name: 'Ibiza', coords: '38.90°N 1.43°E', tag: 'Festival Stages' },
];

const HeroSection = () => {
  const videoRef = useRef(null);
  const heroRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="hero-section" ref={heroRef} data-testid="hero-section">
      {/* Video Background */}
      <div className="video-background">
        <video ref={videoRef} autoPlay muted loop playsInline className="hero-video">
          <source src="/hero-video.mp4" type="video/mp4" />
        </video>
        <div className="video-overlay"></div>
        <div className="noise-overlay"></div>
        <div className="scanlines"></div>
      </div>

      {/* Main Content — Left Aligned */}
      <div className="hero-content-wrapper">
        <div className={`hero-content ${loaded ? 'hero-loaded' : ''}`}>
          {/* Overline */}
          <div className="hero-overline">
            <span className="overline-dash"></span>
            <span className="overline-text">Anyone Music Records</span>
          </div>

          {/* Main Headline */}
          <h1 className="hero-headline" data-testid="hero-headline">
            <span className="headline-line line-1">Music Lives</span>
            <span className="headline-line line-2">In <em className="accent-word">Everyone</em>.</span>
            <span className="headline-line line-3">We Just Turn</span>
            <span className="headline-line line-4">It <span className="highlight-word">Up</span>.</span>
          </h1>

          {/* Tagline */}
          <p className="hero-tagline" data-testid="hero-tagline">
            A new electronic music label and creative collective releasing music with identity, movement, and staying power. Built for listeners, DJs, and the spaces in between.
          </p>

          {/* CTAs */}
          <div className="hero-cta">
            <a href="/releases" className="cta-primary" data-testid="hero-cta-releases">
              <span>Listen Now</span>
              <ArrowRight size={18} />
            </a>
            <a href="/artists" className="cta-secondary" data-testid="hero-cta-demo">
              Explore Artists
            </a>
          </div>
        </div>

        {/* City Badges — Floating Right Side */}
        <div className={`hero-cities ${loaded ? 'hero-loaded' : ''}`}>
          {CITIES.map((city, i) => (
            <div
              key={city.name}
              className="city-card"
              style={{ animationDelay: `${0.6 + i * 0.15}s` }}
              data-testid={`city-badge-${city.name.toLowerCase()}`}
            >
              <span className="city-coords">{city.coords}</span>
              <span className="city-name">{city.name}</span>
              <span className="city-tag">{city.tag}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom scroll indicator */}
      <div className="scroll-indicator">
        <span className="scroll-text">Scroll</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default HeroSection;
